/**
 * Created by robert.lavoie on 11/6/17.
 */

/**
 * Interface for a job query parameters
 *
 * @interface
 */
export interface JobQueryParams {
  location?: string;
  lat?: string;
  lng?: string;
  sort?: string;
  view?: string;
  rad?: number;
  start?: number;
  jobTitles?: string;
  jobTypes?: string;
  ne?: string;
  sw?: string;
}

class LastSearchState {
  params: JobQueryParams = {};
}

const lastSearchState = new LastSearchState();
export { lastSearchState };
